import { Pipe, PipeTransform } from '@angular/core';
/**
 * This is a common pipe to sort the given data, it takes three parameters
 * 
 * value - This will the list of data
 * 
 * key - The is use to filter data based on key
 * 
 * searchText - The search text
 */
@Pipe({
  name: 'sortData'
})
export class SortDataPipe implements PipeTransform {

  transform(value: any, key, searchText: any): any {
    if(searchText)
      value = value.filter(x=> x[key].includes(searchText))
    return value;
  }

}
